// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22IvR","colBig":"styles_colBig__15P7G","colSmall":"styles_colSmall__2N7KQ"};